var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBusiness16Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.a,.b{stroke:#f28705;stroke-miterlimit:10;stroke-width:0.75px;}.b{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.4 0.582)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.41,7.52A1.578,1.578,0,0,1,10.831,9.1H4.369A1.578,1.578,0,0,1,2.79,7.52",
    transform: "translate(-0.001 -0.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.34,4.889v-1.5c0-.175.111-.323.24-.323h4.431c.129,0,.24.148.24.323v1.5",
    transform: "translate(-0.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.671,11.918H3.519a.741.741,0,0,1-.739-.739v-5.4a.741.741,0,0,1,.739-.739h8.152a.741.741,0,0,1,.739.739v5.41A.733.733,0,0,1,11.671,11.918Z",
    transform: "translate(0 -0.151)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 1.773,
    transform: "translate(5.143 7.852)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 1.773,
    transform: "translate(10.055 7.852)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 16,
    height: 16
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness16Px);
export default __webpack_public_path__ + "static/media/Icon_Business_16px.a52befba787e9c9c40a6c7fab96777b9.svg";
export { ForwardRef as ReactComponent };